"use client";

import { createContext, useContext } from "react";
import type { OddsLiveClient } from "@/lib/odds-screen/live/client";
import type { DisplayPlayerProp } from "@/components/optimizer/utils-v2";

export type WhalesUnlockTrigger = "cell" | "header" | "weights" | "required_books";

export type WhalesGate =
  | { readonly kind: "unlocked"; readonly client: OddsLiveClient }
  | { readonly kind: "locked"; readonly unlock: (trigger: WhalesUnlockTrigger) => void };

export const WhalesGateContext = createContext<WhalesGate | null>(null);

export const WhalesColumnShown = createContext(false);

export class MissingWhalesGate extends Error {
  constructor() {
    super("The Whales column rendered outside a WhalesGateProvider, so it cannot tell a Diamond member from a locked one");
    this.name = "MissingWhalesGate";
  }
}

export function useWhalesGate(): WhalesGate {
  const gate = useContext(WhalesGateContext);
  if (gate === null) throw new MissingWhalesGate();
  return gate;
}

export function useWhalesSlot(row: Pick<DisplayPlayerProp, "whales">): boolean {
  return useContext(WhalesGateContext)?.kind === "locked" || row.whales != null;
}
